import { memo } from 'react';

import { ViewTypeName } from '@air/api/types';

import { PublicBoardActivityContainer } from '~/components/PublicBoardActivityContainer';
import { PublicShowcaseAssetModal } from '~/components/PublicShowcaseAsset/PublicShowcaseAssetModal';
import { PublicShowcaseGalleryView } from '~/components/v2/components/showcase/gallery/PublicShowcaseGalleryView';
import { usePublicShowcaseConfigViewFields } from '~/components/v2/components/showcase/hooks/usePublicShowcaseConfigViewFields';
import { PublicShowcaseBlocks } from '~/components/v2/components/showcase/PublicShowcaseBlocks';
import { useIsSearchActive } from '~/hooks/search/useIsSearchActive';
import { useRerenderOnMount } from '~/hooks/useRerenderOnMount';
import { AnnotationProvider } from '~/providers/AnnotationProvider/AnnotationProvider';
import { usePublicAssetModalNavigation } from '~/providers/PublicAssetModalNavigationProvider';
import { useScrollElementContext } from '~/providers/ScrollElementProvider';

export const PublicShowcaseContent = memo(() => {
  // Home-only: this component unmounts when a board is drilled, so home fields do not fight the board.
  usePublicShowcaseConfigViewFields();

  const { activeClipId: clipId } = usePublicAssetModalNavigation();
  const { isMounted } = useRerenderOnMount();
  const { scrollElementRef } = useScrollElementContext();
  const { isSearchActive } = useIsSearchActive();
  // @TODO(REV-877, REV-878): Replace with currentViewTypeNameSelector when Table View and Kanban View are implemented
  const viewTypeName = ViewTypeName.gallery;

  return (
    <div className="grow" data-testid="PUBLIC_COLLECTION_CONTENT_CONTAINER">
      {/* View vs SEARCH, the only axis left: every showcase renders through the block stack — a
          never-authored one on the implicit defaults the read seam substitutes — so there is no
          authored-vs-unauthored fork and no first-edit flip. An active search swaps in the flat
          gallery because it is the results page's body: it searches the WHOLE showcase, every
          sub-page and board-held item, not the page the viewer was standing on (the
          includeSubPages/'all' scope in the layout contract's useGalleryViewItems). */}
      {viewTypeName === ViewTypeName.gallery &&
        (isSearchActive ? <PublicShowcaseGalleryView scrollElementRef={scrollElementRef} /> : <PublicShowcaseBlocks />)}
      {!!clipId && isMounted && (
        <AnnotationProvider>
          <PublicShowcaseAssetModal />
        </AnnotationProvider>
      )}
      <PublicBoardActivityContainer />
    </div>
  );
});

PublicShowcaseContent.displayName = 'PublicShowcaseContent';
